import React, { Fragment, useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import FormSection from '../formSectionNew';
import localization from 'assets/localization/localization';
import DropDownInput from 'components/sales/Input/dropDownInput/dropDownInput';
import ButtonWithIcon from 'components/sales/buttons/buttonWithIcon/buttonWithIcon';
import { handleValidateObj } from 'constants/objValues/objvalues';
import ConstantInput from 'components/sales/Input/constantInput/constantInput';
import Inventory from 'components/sales/inventory/inventory';
import { DatePickerInput } from 'rc-datepicker';
import { FormGroup } from 'react-bootstrap';
import FileUpload from 'components/sales/fileUpload/fileUpload';
import * as moment from 'moment';

const AdvancePayment = ({
  data,
  handleValue,
  getTag,
  imageUploadUrl,
  getTagById,
  prefilledData
}) => {
  
  const {
   tags
  } = data;
 
  const [inputListAd, setInputListAd] = useState([{ installation_amt:"",cartage_amt:"",rental_charge: "", tag_charge: "",adv_amount:"",payment_mode:"",capex_charge:"" ,reference_number:"",tds_check:"",tds_amt:"",remark:"",gst_amt:"",payment_photo:"",payment_photo_old:"" ,adv_payment_date:"",status:"",trans_amount:""}]);
  const [payData, setPayData] = useState();
  const [isTarget, setIsTarget] = useState('');
  const [isFocus1, setIsFous1] = useState(true);

  useEffect(() => {
    if (
      prefilledData?.leadAdvPayment !== undefined &&
      prefilledData?.leadAdvPayment !== null &&
      prefilledData?.leadAdvPayment !== []
    ) {
      const {
        leadAdvPayment
      } = prefilledData;
      if (Object.keys(prefilledData.leadAdvPayment).length !== 0) {
        setTimeout(() => {
          setInputListAd(leadAdvPayment);
        }, 200);
              
              setIsTarget(1);
      }
    }
  }, [prefilledData]);
  
  const handleDateChange1 = (date, dateString) => {
    const selectedDate = dateString;
    // setInputListAd({
    //   ...inputListAd,
    //   adv_payment_date: selectedDate,
    // });
    // const list = [...inputListAd];
    //     list[index][name] = value;
    //     setInputListAd(list);
    
  };

      // handle input change
    const handleInputChange = (e, index) => {
      const re = /^[0-9\b]+$/;
      if (e.target.value === '' || re.test(e.target.value)) {
        const { name, value } = e.target;
        const list = [...inputListAd];
        list[index][name] = value;
        setInputListAd(list);
      }
      else{
        return;
      }
     
    };
    const handleDateChange = (e, index,name) => {
      const current_datetime = moment(e).format("YYYY-MM-DD");
      const list = [...inputListAd];
      list[index][name] = current_datetime;
      setInputListAd(list);
      
    };
    const handledropDownChange = (e, index,name) => {
      // console.log(e);
      const { value,id} = e;
      const list = [...inputListAd];
      list[index][name] = id;
      setInputListAd(list);
    };

    const handleConstInput = (e, index,name) => {
      // console.log(e);
      const list = [...inputListAd];
      list[index][name] = e;
      setInputListAd(list);
    };
    
    // handle click event of the Remove button
    const handleRemoveClick = index => {
      const list = [...inputListAd];
      list.splice(index, 1);
      setInputListAd(list);
    };
    // handle click event of the Add button
    const handleAddClick = () => {
      setInputListAd([...inputListAd, { installation_amt:"",cartage_amt:"",rental_charge: "", tag_charge: "",adv_amount:"",payment_mode:"",capex_charge:"" ,reference_number:"",tds_check:"",tds_amt:"",remark:"",gst_amt:"",payment_photo:"",payment_photo_old:"" ,adv_payment_date:"",status:"",trans_amount:"" }]);
    };

    const handleFirstTime = () => {
      setIsTarget(1);
    };

    const handleRemoveAll = () =>{
      setIsTarget(0);
      setInputListAd([]);
    }


    const handleFormData = () => {
      if (inputListAd) {
        console.log('Ad data');
        handleValue({
          advData: inputListAd,
        });
        
      } else {
        console.log('Ad no data')
        handleValue(null);
      }
    };
  
    useEffect(() => {
      handleFormData();
    }, [inputListAd]);

    // console.log(data.commercialData);
    const advancePayment = () =>{

      return (
        <>
        {inputListAd.map((x, i) => {
          return (
            <div>
              <div className="row">
                <div className="col-5">
                    <DropDownInput
                
                      label={localization.paymentMode}
                      data={[
                        { id: 'Cash', name: 'Cash' },
                        { id: 'Cheque', name: 'Cheque' },
                        { id: 'NEFT', name: 'NEFT' },
                        { id: 'IMPS', name: 'IMPS' },
                        { id: 'RTGS', name: 'RTGS' },
                      ]}
                      required
                      errorMsg={localization.paymentMode}
                      getIdValue={(val) =>{
                        setPayData({
                          ...payData,
                          payment_mode: val.id,
                        });
                        handledropDownChange(val,i,'payment_mode');
                      }
                      }
                      // onChange={e => handleInputChange(e, i)}
                      value={x?.payment_mode}
                      isStarRequired={true}
                  />
            
                </div>
                <div className="col-5">
                <ConstantInput
                  label={localization.transAmount}
                  type='number'
                  // value={locationData.billGeoState}
                  placeholder='As mentioned on Cheque'
                  handleChange={(val) => {
                    setPayData({
                      ...inputListAd,
                      trans_amount: val,
                    });
                    handleConstInput(val,i,'trans_amount');
                  }}
                  value={x?.trans_amount}
                  
                />
                </div>
                <div className="col-5">
                <ConstantInput
                  label={localization.referenceNumber}
                  // value={locationData.billGeoState}
                  handleChange={(val) => {
                    setPayData({
                      ...inputListAd,
                      reference_number: val,
                    });
                    handleConstInput(val,i,'reference_number');
                  }}
                  value={x?.reference_number}
                  placeholder='Cheque & Reference Number'
                />
               </div>
               <div className="col-5">
               <FormGroup
                className={`date custom_date_picker ${isFocus1 ? 'active-date' : ''}`}
                >
              <label>
                  {localization.transactionDate}
                  <span className="label-star" style={{ color: 'red' }}>
                    {' '}
                    *{' '}
                  </span>
                </label>
                <DatePickerInput
                    // onChange={handleDateChange1}
                    onChange={e => handleDateChange(e, i,'adv_payment_date')}
                    // onShow={() => setIsFous1(true)}
                    autoClose
                    closeOnClickOutside
                    showOnInputClick
                    locale="en"
                    className="my-custom-datepicker-component"
                    // minDate={new Date()}
                    required
                    format="DD-MM-YYYY"
                    displayFormat="DD-MM-YYYY"
                    returnFormat="YYYY-MM-DD"
                    value={x?.adv_payment_date}
                  />
                  {!isFocus1 && (
                    <label className="error date_error">
                      {localization.transactionDate}
                    </label>
                  )}
               </FormGroup>
               </div>

              </div>
              <div className="row">
              {x.payment_mode && (x.payment_mode == 'Cash' || x.payment_mode == 'Cheque') && (
                <div className="col-5">
                  <DropDownInput
              
                    label={localization.status}
                    data={[
                      { id: 'Deposited in Bank', name: 'Deposited in Bank' },
                      { id: 'Collected from Client', name: 'Collected from Client' },
                      { id: 'Deposited to Finance', name: 'Deposited to Finance' },
                    ]}
                    required
                    errorMsg={localization.paymentMode}
                    getIdValue={(val) =>{
                      setPayData({
                        ...payData,
                        status: val.id,
                      });
                      handledropDownChange(val,i,'status');
                    }}
                    value={x?.status}
                    // onChange={e => handleInputChange(e, i)}
                    
                    isStarRequired={true}
                />
        
              </div>
              )}
              {x.payment_mode && (x.payment_mode == 'NEFT' || x.payment_mode == 'IMPS' || x.payment_mode == 'RTGS') && (
              <div className="col-5">
                    <DropDownInput
                
                      label={localization.status}
                      data={[
                        { id: 'Online Transaction by Client', name: 'Online Transaction by Client' },
                      ]}
                      required
                      errorMsg={localization.paymentMode}
                      getIdValue={(val) =>{
                        setPayData({
                          ...payData,
                          status: val.id,
                        });
                        handledropDownChange(val,i,'status');
                      }
                      }
                      value={x?.status}
                      // onChange={e => handleInputChange(e, i)}
                      
                      isStarRequired={true}
                  />
            
                </div>
              )}
              </div>


            <div className="row">
              <div className="col-4">
              <lable> {localization.installationCharge}<span style={{ color: 'red' }}>*</span>
              </lable>
              
              <input
                  className="form-control"
                  name="installation_amt"
                  // placeholder={localization.installationCharge}
                  value={x.installation_amt}
                  onChange={e => handleInputChange(e, i)}
                  required
                />
               
              </div>
              {/* Cartage cost */}
              <div className="col-2">
              <lable> {localization.cartage_amount}</lable>
              <input
                  className="form-control"
                  name="cartage_amt"
                  // placeholder={localization.installationCharge}
                  value={x.cartage_amt}
                  onChange={e => handleInputChange(e, i)}
                  //required
                />
               
               </div>
               {( (data.commercialData.commercial_type_id === 6 || data.commercialData.commercial_type_id === 7) &&  <div className="col-2">
               <lable> {localization.rentalCharge}</lable>
              <input
                  className="form-control"
                  name="rental_charge"
                  // placeholder={localization.rentalCharge}
                  value={x.rental_charge}
                  onChange={e => handleInputChange(e, i)}
                />
              </div>)}
              
              {(data.commercialData.commercial_type_id == 5 && <div className="col-2">
               <lable> {localization.capexCharge}</lable>
                <input
                    className="form-control"
                    name="capex_charge"
                    // placeholder={localization.capexCharge}
                    value={x.capex_charge}
                    onChange={e => handleInputChange(e, i)}
                  />
               </div>
               )}
               
               <div className="col-2">
               <lable> {localization.tagCharge}</lable>
                
                <input
                    className="form-control"
                    name="tag_charge"
                    // placeholder={localization.tagCharge}
                    value={x.tag_charge}
                    onChange={e => handleInputChange(e, i)}
                  />
               </div>
                
               <div className="col-2">
               <lable> {localization.amount}</lable>
               <input
                    className="form-control"
                    name="adv_amount"
                    // placeholder={localization.amount}
                    value={(Number(x.installation_amt)+Number(x.rental_charge)+Number(x.capex_charge)+Number(x.tag_charge)+Number(x.cartage_amt))}
                    onBlur={e => handleInputChange(e, i)}
                    disabled
                  />
                {/* <ConstantInput
                  label={localization.amount}
                  disabled
                  value={(x.tag_charge+x.capex_charge)}
                  handleChange={(val) => {
                    setPayData({
                      ...payData,
                      adv_amount: val,
                    });
                  }}
                /> */}
               </div>
               </div>
               <br/>
               <div className="row">
    
               <div className="col-5">
               
               <DropDownInput
                
                      label={localization.tdsAmount}
                      data={[
                        { id: 'Yes', name: 'Yes' },
                        { id: 'No', name: 'No' },
                      ]}
                      required
                      errorMsg={localization.tdsAmount}
                      getIdValue={(val) =>{
                        setPayData({
                          ...payData,
                          tds_check: val.id,
                        });
                        handledropDownChange(val,i,'tds_check');
                      }
                      }
                      value={x?.tds_check}
                      // onChange={e => handleInputChange(e, i)}
                      
                      isStarRequired={true}
                  />
               </div>
              <div className="col-5">
              {x.tds_check && x.tds_check == 'Yes' && (
                <ConstantInput
                  label={localization.tdsAmount}
                  // value={locationData.billGeoState}
                  handleChange={(val) => {
                    setPayData({
                      ...payData,
                      tds_amt: val,
                    });
                    handleConstInput(val,i,'tds_amt');
                  }}
                  value={x?.tds_amt}
                  
                />
              )}
               </div>
              
              </div>
              <div className="row">
                <div className="col-5">
                <ConstantInput
                    label={localization.remarks}
                    // value={locationData.billGeoState}
                    handleChange={(val) => {
                      setPayData({
                        ...payData,
                        remark: val,
                      });
                      handleConstInput(val,i,'remark');
                    }}
                    value={x?.remark ? x?.remark : ''}
                    
                  />
                </div>
               <div className="col-5">
               <FileUpload
                        id={"uploadAdvPay"+i}
                        multiple
                        accept="image/*"
                        documentUploadUrl={imageUploadUrl}
                        
                        onChange={(val) => {
                          // setPayData({ ...payData, payment_photo: val.toString() })
                          handleConstInput(val.toString(),i,'payment_photo');
                        }}
                        prefilledFilename={x.payment_photo_old?x.payment_photo_old:x.payment_photo?x.payment_photo:''}
                      >
                        <span className="btn btn-transparent">
                          {localization.uploadPaymentPhotos}
                        </span>
                      </FileUpload>
                 </div>
               
               
              <div className="btn-box">
                {inputListAd.length !== 1 && <button
                  // className="mr10"
                  onClick={() => handleRemoveClick(i)} className="btn btn-sm btn-danger mr-1">Remove</button>}
                {inputListAd.length - 1 === i && <button className="btn btn-sm btn-primary" onClick={handleAddClick}>Add</button>}
              </div>
              <hr/>
            </div>
            </div>
          );
        })} 
        </>
      );
    };




  return (
    <Fragment>
      <FormSection title={localization.advancePayment}>
        
        { (isTarget == 1 && (
          advancePayment()
        ))
        }
        {isTarget !== 1 &&
        <div className="form-btn full-width">
          <button className="btn btn-primary"  onClick={handleFirstTime}>Add</button>
        </div>
        }
        {isTarget === 1 &&
        <div className="form-btn full-width">
          <button className="btn btn-danger"  onClick={handleRemoveAll}>Remove All</button>
        </div>
        }
        {isTarget === 1 &&
        <button className="btn btn-sm btn-danger"  onClick={handleRemoveAll}>Remove All</button>
        }
        {/* <div className="w-100">
          <ButtonWithIcon
            title={localization.addMoreGates}
            onClick={addGates}
          />
        </div> */}
      
      </FormSection>
      
    </Fragment>
  );
};
AdvancePayment.propTypes = {
  data: PropTypes.any,
  handleValue: PropTypes.func,
};
export default AdvancePayment;
